//@ts-ignore
//@ts-nocheck
import { API, Auth } from "aws-amplify";
import React, { useRef, useEffect, useState } from "react";
import { FormContext, useForm } from "react-hook-form";
import { DualRing } from "react-loading-io";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  getAdditionalInfo1,
  getAdditionalInfo2,
  getAdditionalInfo2Insured,
  getAdditionalInfo2Contractor,
  getQuizDPS,
  getCountryOA
} from "../../Store/quiz/actions";
import {
  alert,
  apiCliente,
  modalError,
  modalSteps,
  stateAlert,
  stepPosition,
  updateClient,
  addInsured,
  addContractor,
  addAcumulated
} from "../../Store/simulate/actions";
import useBeforeFirstRender from "../../customHook/useBeforFirstRender";

import NavCase from "../../Components/FormElements/NavCase";
import NavResponsive from "../../Components/FormElements/NavResponsive";
import Title from "../../Components/FormElements/Title";
import AlertNotifications from "../../Components/FormElements/AlertNotifications";
import BreadCrumbs from "../BreadCrumbs";
import ModalInformative from "../../Components/ModalInformative";
import Footer from "../../Components/Footer";
import ModalSteps from "./FormElements/ModalSteps";
import TabTitle from '../../Components/tabTitle'
import IconBack from "../../Resources/svg/Icons/IconBack";

import { transformInsuredData, transformLegalData, transformLegalRepresentativeData, transformNaturalData} from '../../Utils/simulaciones/simulaciones'
import { InsuredForm, ContractorEntityForm, ContractorPersonForm } from "../../Components/stepperComponents/clientData";
import Button from "../../Components/FormElements/Button";

export const ClientData = () => {

  const data = useSelector((state: any) => state.simulate.policy.client);
  let dataRedux;
  if (Object.entries(data).length !== 0) {
    dataRedux = data.datosCliente.datosParticulares;
  }

  const client = data.datosCliente;
  const codProd = data.producto.codigo;
  const simulation = data.datosSimulacion;

  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const methods = useForm({ mode: "onChange" });
  const { handleSubmit, register, errors, watch, getValues } = methods;
  const store = useSelector((state: any) => state.data);
  const { asegurado, contratante } = data;

  const [ activeTab, setActiveTab ] = useState('insured');

  const [clientInfo, setClientInfo] = useState<any>(null);

   const [nameUbigeo, setNameUbigeo] = useState<any>({
    province: "",
    department: "",
    district: "",
  });

  const [contractorInfo, setContractorInfo] = useState<any>(null);

    const [nameUbigeoContact, setNameUbigeoContact] = useState<any>({
    province: "",
    department: "",
    district: "",
  });

    const [nameUbigeoPerson, setNameUbigeoPerson] = useState<any>({
    province: "",
    department: "",
    district: "",
  });

    const [nameUbigeoInsured, setNameUbigeoInsured] = useState<any>({
    province: "",
    department: "",
    district: "",
  });

  const [clientAsegurado, setClientAsegurado] = useState({});

  const [enableButton, setEnableButton] = useState(true);

  const contractorType = data.contratante.typeContractor;

  const [formInsuredValid, setFormInsuredValid] = useState<bolean | null>(false);
  const [formContractorValid, setFormContractorValid] = useState<boolean | null>(false);

  const CONTRACTOR_EQUAL_INSURED = Object.keys(contratante).length === 0;
  const CONTRACTOR_DIFF_INSURED = Object.keys(contratante).length !== 0;

  useEffect(() => {
    try {
      dispatch(addAcumulated({}));
      getQuizDPS(dispatch);
      getCountryOA(dispatch);

      getAboveValidators();
      getAdditionalInfo2Insured(dispatch);
      if(CONTRACTOR_DIFF_INSURED) getAdditionalInfo2Contractor(dispatch);
      if (client && client.documento && client.tipoDoc) {
        getDataClient(client.documento, client.tipoDoc.valor);
      }
      dispatch(stepPosition(1));
    } catch (err) {
      history.push("/cotizaciones/error-simulacion", {
        timeOut: false,
      });
    }
    //getUbigeos(null, null, null);
  }, []);

  const getAboveValidators = async () => {
    try {
      const responseAuth: any = await Auth.currentSession();

      const { idToken: { payload: user, jwtToken } } = responseAuth;

      const request = {
        tipoDocumento: client.tipoDoc.valor.toString(),
        numeroDocumento: client.documento,
        declaredCurrency: simulation.moneda.iso,
        declaredAmount: simulation.prima,
      }; 
      const response = await API.post("api-rentas", "/plaft/step4-validation", {
        body: request
      });
  
      if(!response || response.statusCode !== 200){
        history.push("/cotizaciones/error-simulacion", {
          timeOut: false,
        });
        return;
      } else if(response.statusCode === 200){
        const {body: {isAbove10k, isAbove50k, usdToPenRate, totalPremiumInUSD}} = response;
          dispatch(addAcumulated({isAbove10k, isAbove50k, usdToPenRate, totalPremiumInUSD}));
          getAdditionalInfo1(dispatch, codProd, isAbove10k);
      }
    } catch(error) {
      console.error(error);
    }
  } 

  const getDataClient = async (document: any, typeDoc: any) => {
    setLoading(true);

    const params = {
      numDocumento: document,
      tipoDocumento: typeDoc,
      idSimulacion: data.idSimulacion,
    };

    try {
      const response = await API.post("api-rentas", "/client", {
        body: params,
        headers: {},
      });

      if (response.status === 404) {
        setClientAsegurado(data.asegurado);
        dispatch(apiCliente({}));
      }
      if (response.status === 500) {
        dispatch(stateAlert(true));

        dispatch(
          alert({
            type: "danger",
            title: "¡Upps, tenemos un problema!",
            message: `Ha ocurrido un error inesperado, se debe volver a cotizar`,
          })
        );

        setTimeout(() => {
          history.push("-1");
        }, 4000);
      }
      
      if (response.status === 200) {
        setClientInfo({
          ...clientInfo,
          id: response.data.idetercero,
          typeDoc: `${typeDoc}`,
          document: document,
          names: response.data.nombres,
          firstName: response.data.apellidoPaterno,
          lastName: response.data.apellidoMaterno,
          birthdate: response.data.fecNacimiento,
          sexo: response.data.sexo,
          mobile: response.data.celular,
          email: response.data.correo,
        });

        if(Object.keys(response.data.datosContratante).length !== 0){
          if(contractorType === 'PERSON'){
            setContractorInfo({
              ...contractorInfo,
              typeDoc: response.data.datosContratante.typeDoc,
              document: response.data.datosContratante.nroDoc,
              names: response.data.datosContratante.names,
              firstName: response.data.datosContratante.firstName,
              lastName: response.data.datosContratante.lastName,
              birthdate: response.data.datosContratante.birthday,
              sexo: response.data.datosContratante.sexo,
              phone: response.data.datosContratante.phone,
              email: response.data.datosContratante.email,
            });
          } else if(contractorType === 'ENTITY'){
            setContractorInfo({
              ...contractorInfo,
              cellphone: response.data.datosContratante.cellphone,
              companyName : response.data.datosContratante.companyName,
              email: response.data.datosContratante.email,
              giro: response.data.datosContratante.giro,
              nroDoc: response.data.datosContratante.nroDoc,
              oportunidad: response.data.datosContratante.oportunidad,
              phone: response.data.datosContratante.phone,
              typeDoc: response.data.datosContratante.typeDoc
            });
          }
        }
        dispatch(apiCliente(response.data));
        if (response.data.idetercero === null) {
          dispatch(modalError(true));
        }
      } else {
        setClientInfo({
          ...clientInfo,
          names: response.data.nombres,
          firstName: response.data.apellidoPaterno,
          lastName: response.data.apellidoMaterno,
          birthdate: response.data.fecNacimiento,
        });
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      useBeforeFirstRender(client);
    }
  };

  const onSubmit = (values: any, profileType: string) => {

    if(profileType === 'INSURED' ){
      values.address.nameUbigeo = nameUbigeoInsured;
      let data = {
        idetercero: clientInfo.id,
        datosParticulares: {
          ...clientInfo,
          id: undefined,
          ...values /*,
          address*/,
        },
        via: 'nameVia',
      };
      dispatch(updateClient(data));
      dispatch(addInsured({...values}))
      if(CONTRACTOR_EQUAL_INSURED){
      setTimeout(() => {
            history.push("/cotizaciones/datos-laborales");
            dispatch(stepPosition(2));
          }, 500);
      } else if (CONTRACTOR_DIFF_INSURED){
        setActiveTab('contractor');
        window.scrollTo(0, 0);
      }
    }else{
      if(contractorType === 'ENTITY'){
        values.address.nameUbigeo = nameUbigeoContact;
        values.addressv2.nameUbigeo = nameUbigeo;
      } else {
        values.address.nameUbigeo = nameUbigeoPerson;
      }
      dispatch(addContractor({...values, birthdate: contractorInfo.birthdate}));
      setTimeout(() => {
        history.push("/cotizaciones/datos-laborales");
        dispatch(stepPosition(2));
      }, 500);
    }
  };

  const handleOpenModal = () => {
    dispatch(modalSteps(true));
  };

  useBeforeFirstRender(client);

  useEffect(() => {
    const loopingErros = Object.values(errors)
      .map((err: any) => err.message)
      .at(-1);
    window.digitalData.push({
      log: {
        message: loopingErros,
      },
      event: "trackLog",
    });
  }, [errors]);

  useEffect(() => {
    window.digitalData.push({
      virtual: {
        name: "aiv:inversion-global:cotizar:datos-personales",
      },
      event: "trackVirtual",
    });
  }, []);

  return (
    <div>
      <div className="wrap">
        <NavResponsive position={1} title="Datos personales" />
        <div className="content-box d-flex">
          <div className="nav-case">
            <BreadCrumbs
              rutas={[{ link: "Simulaciones" }, { link: "Cotización" }]}
            />
            <div className="nav-case__routing">
              <IconBack className="nav-case__back" onClick={handleOpenModal} />
              <div className="nav-case__title">Datos personales</div>
              <NavCase />
            </div>
          </div>

          <div className="form-register">
            {loading && (
              <div className="loading-field">
                <DualRing size={50} />
              </div>
            )}

            { CONTRACTOR_DIFF_INSURED && <div className="detailsTab__tabs-maxwidth">
              <TabTitle id={'Asegurado'} onClick={(e: any) => dataRedux ?  setActiveTab('insured') : false } defaultChecked={ activeTab === 'insured' ? true : null} disabled={dataRedux ? false : true} />
              <TabTitle id={'Contratante'} onClick={(e: any) => dataRedux ?  setActiveTab('contractor') : false } defaultChecked={ activeTab === 'contractor' ? true : null} disabled={dataRedux ? false : true} />
            </div> }

            {activeTab === 'insured' && <InsuredForm setNameUbigeo={setNameUbigeoInsured} nameUbigeo={nameUbigeoInsured} userData={clientInfo} setFormInsuredValid={setFormInsuredValid} onSubmit={(values: any) => onSubmit(values, 'INSURED')} />}
            {activeTab === 'contractor' &&
              <>
                {contractorType === 'PERSON' && <ContractorPersonForm  setNameUbigeo={setNameUbigeoPerson} nameUbigeo={nameUbigeoPerson} setLoading={setLoading} contractorData={contractorInfo} setFormContractorValid={setFormContractorValid} onSubmit={(values: any) => onSubmit(values, 'CONTRACTOR')} />}
                {contractorType === 'ENTITY' && <ContractorEntityForm  nameUbigeoContact={nameUbigeoContact} setNameUbigeoContact={setNameUbigeoContact} setNameUbigeo={setNameUbigeo} nameUbigeo={nameUbigeo} setLoading={setLoading} contractorData={contractorInfo} setFormContractorValid={setFormContractorValid} repLegalData={data.repLegal} onSubmit={(values: any) => onSubmit(values, 'CONTRACTOR')} />}
              </>
            }           
               
          </div>
        </div>
      </div>

      <ModalSteps />
      <AlertNotifications />
      <ModalInformative title="¡Recuerda!" text="2" />
      <Footer />
    </div>
  );
};
